import { Button } from "react-daisyui";
import { IconRefresh, IconRefreshAlert } from "@tabler/icons-react";
import { LbcAlert } from "src/core/components/alert/LbcAlert";
import { classNames } from "src/core/utilities/classNames";
import { useServiceWorkerUpdateContext } from "./ServiceWorkerUpdateContext";

interface Props {
    className?: string;
}

/** Where the frame says an update exists: offered once installable, only announced before that */
export const UpdateNotice = ({ className }: Props) => {
    const { update, showAlert, applyUpdate, dismiss, localVersion, latestVersion } = useServiceWorkerUpdateContext();

    const versions = (
        <p className="text-xs opacity-75 mt-1">
            Current: {localVersion} | Latest: {latestVersion || "unknown"}
        </p>
    );

    if (update === "coming") {
        return (
            <LbcAlert className={classNames("text-left", className)} color="info" icon={IconRefresh} heading="Update on its way">
                <div>
                    <p>It will be ready to install shortly.</p>

                    {versions}
                </div>
            </LbcAlert>
        );
    }

    if (!showAlert) return null;

    return (
        <LbcAlert
            className={classNames("text-left", className)}
            color="warning"
            icon={IconRefreshAlert}
            heading="Update available"
            actions={
                <>
                    <Button type="button" size="sm" color="ghost" onClick={dismiss}>
                        Not now
                    </Button>

                    <Button type="button" size="sm" color="primary" onClick={applyUpdate}>
                        Update now
                    </Button>
                </>
            }
        >
            <div>
                <p>Updating reloads Hub, so finish anything you are part way through first.</p>

                <p>Closing Hub and opening it again applies it on its own.</p>

                {versions}
            </div>
        </LbcAlert>
    );
};
